import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import { addGroupToCart } from "../../actions/closeLoop/CADaddToCartActionCloseLoop";
import { addScenarioGropsCAD } from "../UserFunctions";
import PopupModal from "../PopupModal.js";
import PropTypes from "prop-types";
import { Alert } from "react-bootstrap";
import MiniLoader from "./../../utilityComponents/MiniLoader";

var scenarioNameFlag = false;
class CADPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showpopup: false,
            status: "",
            description: "",
            loading: false,
        };
        this.onScenarioGroupNameChange = this.onScenarioGroupNameChange.bind(this);
        this.SubmitData = this.SubmitData.bind(this);
        this.togglePopup = this.togglePopup.bind(this);
    }

    togglePopup() {
        this.setState((prevState) => {
            console.log("prevState", prevState);
            return {
                status: "",
                showpopup: false,
                error: "",
            };
        });

        if (this.state.status === "Added Succesfully") {
            this.props.useHistory.history.push(`\close_loop/topology`); // eslint-disable-line
        }
    }

    onScenarioGroupNameChange(e) {
        this.setState({ description: e.target.value }, () => {
            if (this.state.description === "") {
                scenarioNameFlag = false;
            } else {
                scenarioNameFlag = true;
                let obj = {
                    description: this.state.description,
                };
                this.props.dispatch(addGroupToCart(obj));
            }
        });
    }

    SubmitData() {
        if (scenarioNameFlag === false) {
            alert("Please fill required fields with correct data");
        } else {
            this.setState({ loading: true });
            const url = window.location.origin.concat("/create_cad_topology");
            const data_for_addition = {
                list_of_grp: this.props.items,
                total_scenario_groups: this.props.count,
                description: this.props.description,
            };
            addScenarioGropsCAD(url, data_for_addition)
                .then((res) => {
                    console.log("response after addition : ", res["data"]["status_message"]);
                    this.setState({
                        status: res["data"]["status_message"],
                        showpopup: !this.state.showpopup,
                        error: "",
                        loading: false,
                    });
                })
                .catch((error) => {
                    this.setState(() => {
                        return {
                            error: error.response.data.message,
                        };
                    });
                });
        }
    }
    render() {
        return (
            <div className="CartPopup">
                <Modal isOpen={true}>
                    <ModalHeader toggle={this.props.closePopup} style={{ color: "#757AF7" }}>
                        Items Added
                    </ModalHeader>
                    <ModalBody>
                        <div className="card">
                            {this.state.error ? (
                                <Alert key="danger" variant="danger">
                                    {this.state.error}
                                </Alert>
                            ) : undefined}
                            <div className="card-body">
                                {this.props.count === 0 ? (
                                    <p>Please Select Scenarios Groups</p>
                                ) : (
                                    <div className="form-group">
                                        <h5 style={{ color: "#008000" }}>
                                            You have selected scenario Groups : {this.props.count}{" "}
                                        </h5>
                                        CAD Topology Tag Name{" "}
                                        <input
                                            type="text"
                                            className="form-control"
                                            list="data"
                                            onChange={this.onScenarioGroupNameChange}
                                            required
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.loading ? (
                            <MiniLoader />
                        ) : this.props.count === 0 ? (
                            <p></p>
                        ) : (
                            <Button
                                color=""
                                style={{ backgroundColor: "#757AF7" }}
                                className="btn btn-primary"
                                onClick={this.SubmitData}
                            >
                                Add To CAD
                            </Button>
                        )}
                    </ModalFooter>
                </Modal>
                {this.state.showpopup ? (
                    <PopupModal text={this.state.status} closePopup={this.togglePopup.bind(this)} />
                ) : (
                    ""
                )}
            </div>
        );
    }
}
// CADPopup.defaultProps = {
//     useHistory: { history: [] },
// };
CADPopup.propTypes = {
    useHistory: PropTypes.object,
    dispatch: PropTypes.func,
    items: PropTypes.array,
    description: PropTypes.string,
    closePopup: PropTypes.func,
    loading: PropTypes.func,
    count: PropTypes.number,
};
CADPopup.defaultProps = {
    useHistory: {},
    dispatch: [],
    items: [],
    description: [],
    closePopup: [],
    count: 0,
};

const mapStateToProps = (state) => {
    return {
        count: state.CAD_close_loop_cart.count,
        items: state.CAD_close_loop_cart.items,
        description: state.CAD_close_loop_cart.description,
    };
};

export default connect(mapStateToProps)(CADPopup);
